<template>
  <MessageBox :class="$style.messageBox" :title="$t('auth.label.signing')" :icon="'generic/info'">
    <p class="mb-4">{{ $t("auth.label.takeMoment") }}</p>
  </MessageBox>
</template>

<script lang="ts" setup>
import { useOidcStore } from "@scayla/core";
import { onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";

import MessageBox from "@/components/MessageBox.vue";
import { Routes } from "@/router";

// createOidc (main.ts) handles this callback and reloads to the stored page. Handling it here as
// well raced it into a login loop (#3511), so this page only recovers from a callback that failed.
const STUCK_CALLBACK_TIMEOUT_MS = 10_000;

const { state } = useOidcStore();
const router = useRouter();

let stuckTimer: ReturnType<typeof setTimeout> | undefined;

onMounted(() => {
  stuckTimer = setTimeout(() => {
    if (!state.value.user) void router.replace({ name: Routes.HOME });
  }, STUCK_CALLBACK_TIMEOUT_MS);
});

onUnmounted(() => {
  clearTimeout(stuckTimer);
});
</script>

<style module lang="scss">
.messageBox {
  width: 100dvw;
  background-color: white;
  text-align: center;
  height: 100dvh;
  justify-content: space-between;
  max-width: unset;
}
</style>
